import { Component, Input } from '@angular/core';

@Component({
    selector: 'topic-image',
    styles: [`
        .topic-image {
            max-height: 80px;
            max-width: 80px;
            margin: 5px;
        }
        
        .topic-initials {
            font-size: 45px;
            font-weight: bold;
            color: #FFFFFF;
            font-variant: all-small-caps;
            width: 80px;
            height: 80px;
        }
        
        .topic-initials-0 {
            background-color: #3949ab;
        }
        
        .topic-initials-1 {
            background-color: #ed6237;
        }
        
        .topic-initials-2 {
            background-color: #212121;
        }
    `],
    template: `
        <img *ngIf="topic.thumbnailImage && topic.thumbnailImage.uri" class="topic-image" [src]="topic.thumbnailImage?.uri">
        <div *ngIf="!topic.thumbnailImage || !topic.thumbnailImage.uri" fxLayoutAlign="center center" ngClass="topic-initials-{{generateIndex()}}" class="topic-image topic-initials">{{initials()}}</div>
    `
})
export class TopicImageComponent {
    @Input() topic;

    initials() {
        const display = this.topic.title ? this.topic.title.replace(/[^0-9a-z ]/gi, '').split(' ').map(function (s) { return s.charAt(0); }).join('') : '';
        return display.length > 2 ? display.substring(0, 2) : display;
    };

    generateIndex = () => {
        if(this.topic && this.topic.title){
            const seed = this.topic.title.split('').reduce( (acc, ch) => ch.charCodeAt(0) + acc, 0);
            return ({0: 0, 1: 1, 2: 2, 3: 0, 4: 1, 5: 2, 6: 0, 7: 1, 8:2, 9: 0})[Math.floor(seed % 10)]
        }
    };
}